(() => {
  const slider = document.getElementById('AnnouncementSlider');
  if (!slider) return;

  const conditional = slider.querySelectorAll('[data-hide-in-ca-az="true"]');
  if (!conditional.length) return;

  const HIDDEN_STATES = ['CA', 'AZ'];
  const CACHE_KEY = 'wabash_geo_state';
  const TTL_MS = 24 * 60 * 60 * 1000;

  const removeConditionalSlides = () => {
    conditional.forEach((el) => el.remove());
    const count = parseInt(slider.dataset.blockCount, 10) || 0;
    slider.dataset.blockCount = Math.max(0, count - conditional.length);
  };

  const readCache = () => {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.state !== 'string' || typeof parsed.ts !== 'number') return null;
      if (Date.now() - parsed.ts >= TTL_MS) return null;
      return parsed.state;
    } catch {
      return null;
    }
  };

  const writeCache = (state) => {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ state, ts: Date.now() }));
    } catch {}
  };

  const cached = readCache();
  if (cached !== null) {
    if (HIDDEN_STATES.includes(cached)) {
      removeConditionalSlides();
    }
    return;
  }

  fetch('https://ipapi.co/json/')
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data) return;
      const state = data.country_code === 'US' && data.region_code ? data.region_code : '';
      writeCache(state);
      if (!HIDDEN_STATES.includes(state)) return;

      window.theme?.announcementBar?.unload?.();
      removeConditionalSlides();
      window.theme?.announcementBar?.init?.();
    })
    .catch(() => {});
})();
